import { useState, useEffect, useRef } from "react"
import { Skeleton } from '@/shared/components/ui/skeleton'
import { BACKEND_URL } from '@/shared/lib/constants'
import { useDocumentTitle } from '@/shared/hooks/use-document-title'

interface LegacyViewProps {
  path: string
  title?: string
}

export function LegacyView({ path, title }: LegacyViewProps) {
  useDocumentTitle(title)
  const [isLoading, setIsLoading] = useState(true)
  const iframeRef = useRef<HTMLIFrameElement>(null)

  // Build the full URL for the Django view
  const iframeSrc = `${BACKEND_URL}${path}`

  useEffect(() => {
    setIsLoading(true)
  }, [path])

  const handleLoad = () => {
    setIsLoading(false)
  }

  return (
    <div className="h-full w-full relative">
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-background">
          <div className="space-y-4 w-full max-w-2xl p-8">
            <Skeleton className="h-8 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
            <div className="space-y-2 pt-4">
              <Skeleton className="h-12 w-full" />
              <Skeleton className="h-12 w-full" />
              <Skeleton className="h-12 w-full" />
            </div>
          </div>
        </div>
      )}
      <iframe
        ref={iframeRef}
        src={iframeSrc}
        title={title || "Tonal Legacy View"}
        className="w-full h-full border-0"
        onLoad={handleLoad}
        style={{
          visibility: isLoading ? "hidden" : "visible",
          minHeight: "calc(100vh - 4rem)",
        }}
      />
    </div>
  )
}
